// extracted by mini-css-extract-plugin
export default {"wrapper":"SaveFormPopup_wrapper__DSIUp","decoration":"SaveFormPopup_decoration__biIEa"};